module.exports = [{
      plugin: require('/mnt/ephemeral/jenkins/workspace/main/corporate-edu-push/corporate/corporate/chart-gatsby/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-NN6WN6","includeInDevelopment":true},
    },{
      plugin: require('/mnt/ephemeral/jenkins/workspace/main/corporate-edu-push/corporate/corporate/gatsby-theme-lucid/plugins/gatsby-source-marketo-lucid/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/mnt/ephemeral/jenkins/workspace/main/corporate-edu-push/corporate/corporate/chart-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
